import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PageTitleService } from '@rd/core/services/page-title/page-title.service';
import { AutoRedemptionSettingType } from '@rd/types/auto-redemption-setting.type';
import { tap } from 'rxjs/operators';
import * as actions from '../actions/auto-redemption-settings-view.actions';

@Injectable()
export class AutoRedemptionSettingsViewNavigationEffects {
  constructor(
    private actions$: Actions,
    private pageTitleService: PageTitleService,
  ) {}

  enterDetailsPageSetPageTitle = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          actions.AutoRedemptionSettingsViewActionTypes.ENTER_DETAILS_PAGE,
        ),
        tap(({ autoRedemptionSettingType, isEverydaySpend }) => {
          this.pageTitleService.setPageTitle(
            'auto-redemption-settings-details',
            {
              autoRedemptionProductType: this.translationKeyMapping(
                autoRedemptionSettingType,
                isEverydaySpend,
              ),
            },
          );
        }),
      ),
    { dispatch: false },
  );

  enterReviewPageSetPageTitle$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.AutoRedemptionSettingsViewActionTypes.ENTER_REVIEW_PAGE),
        tap(({ autoRedemptionSettingType, isEverydaySpend }) => {
          this.pageTitleService.setPageTitle(
            'auto-redemption-settings-review',
            {
              autoRedemptionProductType: this.translationKeyMapping(
                autoRedemptionSettingType,
                isEverydaySpend,
              ),
            },
          );
        }),
      ),
    { dispatch: false },
  );

  enterSuccessPageSetPageTitle$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          actions.AutoRedemptionSettingsViewActionTypes.ENTER_SUCCESS_PAGE,
        ),
        tap(({ autoRedemptionSettingType, isEverydaySpend }) => {
          this.pageTitleService.setPageTitle(
            'auto-redemption-settings-success',
            {
              autoRedemptionProductType: this.translationKeyMapping(
                autoRedemptionSettingType,
                isEverydaySpend,
              ),
            },
          );
        }),
      ),
    { dispatch: false },
  );

  // TODO: This has to be it's own translations. Now it's a "translation in translation" kind of setup.
  translationKeyMapping(
    autoRedemptionSettingType: AutoRedemptionSettingType,
    isEverydaySpend?: boolean,
  ): string {
    switch (autoRedemptionSettingType) {
      case AutoRedemptionSettingType.DigitalGiftCard:
      case AutoRedemptionSettingType.PhysicalGiftCard:
        return 'Gift cards';
        break;
      case AutoRedemptionSettingType.Cash:
        return 'Cashback';
      case AutoRedemptionSettingType.PointsTransfer:
        return isEverydaySpend ? 'Everyday Rewards' : 'Airline Partners';
      default:
        return '';
    }
  }
}
